import React, { FC, PropsWithChildren } from 'react';
import classNames from 'classnames';

import ContentArea from 'components/common/ContentArea';

import { SignInLayoutProps } from './interfaces';

import useStyles from './styles';

const SignInLayout: FC<PropsWithChildren<SignInLayoutProps>> = ({ className, children }) => {
  const classes = useStyles();

  return (
    <div className={classNames('signInLayout', classes.signInLayout, className)}>
      <ContentArea className={classNames(classes.signInCard)} shadowed>
        {children}
      </ContentArea>
    </div>
  );
};

export default SignInLayout;
